import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { Alert, Snackbar } from '@mui/material';
import { del } from '../../../components/hooks/apiFetch';

export const ActionButtons = ({
    onCancel,
    inputIdentifier,
    currentUserAccess,
    cancelText = "Отменить",
    backText = "Мои обработки"
}) => {
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertSeverity, setAlertSeverity] = useState('info');
    const [isDeleting, setIsDeleting] = useState(false);

    const handleUserResults = () => {
        window.location.href = '/myresults';
    };

    const handleUserResultsMiddleClick = (e) => {
        if (e.button === 1) {
            e.preventDefault();
            window.open('/myresults', '_blank');
        }
    };

    const showAlert = (message, severity = 'info') => {
        setAlertMessage(message);
        setAlertSeverity(severity);
        setAlertOpen(true);
    };

    const handleCloseAlert = () => {
        setAlertOpen(false);
    };

    const fetchDeleteTask = async () => {
        await del(`/api/Task/DeleteTask/${encodeURIComponent(inputIdentifier)}`);
        showAlert('Обработка успешно удалена', 'success');
    };

    const fetchLeaveTeam = async () => {
        await del(`/api/TaskFileAccess/DeleteTaskAccess/${encodeURIComponent(currentUserAccess.id)}`);
        showAlert('Вы успешно покинули команду', 'success');
    };

    const handleDelete = async () => {
        let windowText;

        if (currentUserAccess.role === "Creator") {
            windowText = 'Вы уверены, что хотите сделать эту запись недоступной для всех членов команды?'
        } else {
            windowText = 'Вы уверены, что хотите покинуть команду? Эта обработка станет для вас недоступной'
        }

        if (!window.confirm(windowText)) {
            return;
        }

        setIsDeleting(true);

        try {
            if (currentUserAccess.role === "Creator") {
                await fetchDeleteTask();
            }
            else {
                await fetchLeaveTeam();
            }

            setTimeout(() => {
                window.location.href = '/myresults';
            }, 1500);
        } catch (error) {
            console.error('Ошибка при удалении:', error);
            showAlert(error.message || 'Произошла ошибка при удалении', 'error');
        } finally {
            setIsDeleting(false);
        }
    };

    return (
        <>
            <div className="btn-spacing mt-3 justify-content-end">
                <Button
                    className="dt1520-button active-dt1520-button speakers-button default-button"
                    onClick={handleUserResults}
                    onMouseDown={handleUserResultsMiddleClick}
                    draggable="false">
                    {backText}
                </Button>

                {currentUserAccess && (
                    <Button
                        className="dt1520-button active-dt1520-button speakers-button default-button"
                        onClick={() => handleDelete()}
                        disabled={isDeleting}
                        draggable="false">
                        {isDeleting ? 'Удаление...' : (currentUserAccess.role === "Creator" ? 'Удалить' : 'Покинуть команду')}
                    </Button>
                )}

                {onCancel && (
                    <Button
                        className="dt1520-button active-dt1520-button speakers-button default-button"
                        onClick={onCancel}
                        draggable="false">
                        {cancelText}
                    </Button>
                )}
            </div>

            <Snackbar
                open={alertOpen}
                autoHideDuration={3000}
                onClose={handleCloseAlert}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={handleCloseAlert}
                    severity={alertSeverity}
                    variant="filled"
                >
                    {alertMessage}
                </Alert>
            </Snackbar>
        </>
    );
};